import { render, staticRenderFns } from "./PrescreenBanner.vue?vue&type=template&id=3eeff474&scoped=true"
import script from "./PrescreenBanner.vue?vue&type=script&lang=js"
export * from "./PrescreenBanner.vue?vue&type=script&lang=js"
import style0 from "./PrescreenBanner.vue?vue&type=style&index=0&id=3eeff474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeff474",
  null
  
)

export default component.exports